import React from 'react';
import { CTABlock } from './Shared';
const STEPS = [{
  title: 'Pagás y lo recibís en tu mail.',
  text: 'No esperás envío: lo descargás en el momento.'
}, {
  title: 'Elegís el nivel según cómo está hoy:',
  text: 'sentado o en cama, de pie con apoyo, o más independiente.'
}, {
  title: 'Imprimís la actividad del día',
  text: 'y la hacen juntos.'
}, {
  title: 'Anotás en la Bitácora cómo le fue y sus valores.',
  text: 'En la próxima consulta llevás todo ordenado.'
}];
export const ProductIntroSection = () => {
  return <section className="bg-familia-light py-12 md:py-16 px-4 md:px-6" data-id="element-176" data-mp="1posr63c0b5ry">
      <div className="max-w-5xl mx-auto text-center w-full" data-id="element-177" data-mp="24lb8856sgjyz">
        <div className="inline-block bg-familia-accent text-white font-bold text-[13px] sm:text-sm px-5 py-2 rounded-full mb-6 uppercase tracking-wider" data-id="element-178" data-mp="24if767zn9f6b">
          Qué es, sin vueltas
        </div>
        <h2 className="text-[26px] sm:text-6xl md:text-7xl font-display font-bold text-familia-ink mb-5" data-id="element-179" data-mp="3g1rp82xzr8ny">
          VITALIDAD 360
        </h2>

        <p className="text-body text-familia-inkMuted max-w-3xl mx-auto mb-8 md:mb-10" data-id="element-180" data-mp="ags0ailx2un4">
          Un archivo digital (PDF) de más de 240 páginas que descargás apenas
          pagás. Lo imprimís en tu casa o en cualquier fotocopiadora, las veces
          que quieras. Todo está en letra grande, con ilustraciones simples e
          instrucciones que cualquier familiar puede seguir.
        </p>

        <div className="bg-familia-lightCard border border-familia-lightBorder p-6 md:p-10 rounded-3xl mb-12 md:mb-16 text-left max-w-3xl mx-auto" data-id="element-181" data-mp="3nvoetxxt9c2n">
          <h3 className="text-xl md:text-2xl font-display font-bold text-familia-ink mb-3" data-id="element-182" data-mp="3srvn3xdoiznr">
            Qué NO es
          </h3>
          <p className="text-body text-familia-inkMuted" data-id="element-183" data-mp="5gnlcx0nq7z0">
            No es un curso de 40 horas ni una app que hay que aprender a usar.
            No reemplaza al médico ni al kinesiólogo, y no promete curar nada.{' '}
            <span className="text-familia-ink font-semibold" data-id="element-184" data-mp="3957cmcdcqi4p">
              Es una herramienta para que el día a día tenga estructura,
              compañía y estímulo.
            </span>
          </p>
        </div>

        <h3 className="text-[24px] sm:text-3xl font-display font-bold text-familia-ink mb-8 md:mb-10" data-id="element-185" data-mp="bbmhyux54rnh">
          Cómo se usa{' '}
          <span className="text-familia-inkMuted font-sans font-semibold text-[18px] sm:text-xl" data-id="element-186" data-mp="q3ehpykgbx43">
            (15 minutos por día)
          </span>
        </h3>
        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-6 text-left mb-10 md:mb-12" data-id="element-187" data-mp="3tj3hcm9yqbue">
          {STEPS.map((step, i) => <li key={step.title} className="flex lg:flex-col items-start gap-4" data-id="element-188" data-mp="3ol226cfnqwo7" data-mpi={i}>
              <span className="w-11 h-11 rounded-full bg-familia-accent text-white font-display font-bold text-xl flex items-center justify-center shrink-0" data-id="element-189" data-mp="6evydxm4ndxb">
                {i + 1}
              </span>
              <p className="text-body text-familia-inkMuted" data-id="element-190" data-mp="1hqogw3hdivau">
                <span className="font-bold text-familia-ink" data-id="element-191" data-mp="1dro00qigi2qh">{step.title}</span>{' '}
                {step.text}
              </p>
            </li>)}
        </ol>

        <CTABlock href="#precio" tone="light" buttonClassName="md:px-10" data-id="element-192" data-mp="1lcrwa3lso3m9">
          VER TODO LO QUE INCLUYE
        </CTABlock>
      </div>
    </section>;
};